import { Plus, Trash2 } from "lucide-react";

const inp = "border border-slate-300 rounded-md px-2.5 py-1.5 text-sm";

export const XaltixSocialLinks = ({ links, networks, onChange }) => {
  const upd = (i, patch) => onChange(links.map((l, j) => (j === i ? { ...l, ...patch } : l)));
  return (
    <div className="space-y-2" data-testid="xaltix-social-links">
      <div className="text-xs font-semibold text-slate-600">Boutons de la signature <span className="font-normal text-slate-400">— affichés sous le logo et le texte de signature, en bas de chaque e-mail XALTIX envoyé aux entreprises clientes</span></div>
      {links.map((l, i) => (
        <div key={i} className="flex flex-wrap gap-2 items-center" data-testid={`xaltix-social-row-${i}`}>
          <select value={l.network} onChange={(e) => upd(i, { network: e.target.value })} className={inp} data-testid={`xaltix-social-network-${i}`}>
            {Object.entries(networks || {}).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
          </select>
          <input value={l.url} onChange={(e) => upd(i, { url: e.target.value })} placeholder="https://…" className={`${inp} flex-1 min-w-[220px]`} data-testid={`xaltix-social-url-${i}`} />
          <input value={l.label || ""} onChange={(e) => upd(i, { label: e.target.value })} placeholder="Texte du bouton (facultatif)" maxLength={40} className={`${inp} w-48`} data-testid={`xaltix-social-label-${i}`} />
          <button type="button" onClick={() => onChange(links.filter((_, j) => j !== i))} className="p-2 text-rose-600 hover:bg-rose-50 rounded-md" data-testid={`xaltix-social-remove-${i}`} aria-label="Retirer"><Trash2 className="h-4 w-4" /></button>
        </div>
      ))}
      {links.length < 12 && (
        <button type="button" onClick={() => onChange([...links, { network: "linkedin", url: "", label: "" }])} className="inline-flex items-center gap-1 text-sm font-semibold text-[#8a6416] hover:underline" data-testid="xaltix-social-add">
          <Plus className="h-4 w-4" />Ajouter un bouton (Facebook, Instagram, LinkedIn…)
        </button>
      )}
    </div>
  );
};
